/**
 * Largura relativa de cada caractere, em múltiplos do corpo da fonte.
 *
 * Valores medidos em Inter/Helvetica, que é o que o produto usa. Não é exato para toda
 * fonte, mas o erro é pequeno e — o que realmente importa — é o MESMO nos dois lados.
 */
const ADVANCE = {
    ' ': 0.26, '.': 0.26, ',': 0.26, ':': 0.26, ';': 0.26, '!': 0.27, "'": 0.19, '"': 0.32,
    i: 0.24, j: 0.24, l: 0.24, I: 0.26, t: 0.32, f: 0.31, r: 0.35, '1': 0.42,
    m: 0.83, w: 0.72, M: 0.85, W: 0.88, '@': 0.92,
};
const DEFAULT_ADVANCE = 0.53;
/** Maiúsculas são mais largas que a média minúscula. */
const UPPERCASE_FACTOR = 1.16;
export function estimateTextWidth(text, fontSize, letterSpacing = 0) {
    let units = 0;
    for (const char of text) {
        const advance = ADVANCE[char];
        if (advance !== undefined)
            units += advance;
        else
            units += char >= 'A' && char <= 'Z' ? DEFAULT_ADVANCE * UPPERCASE_FACTOR : DEFAULT_ADVANCE;
    }
    return units * fontSize + Math.max(0, text.length - 1) * letterSpacing;
}
/**
 * Fração da largura do quadro que a legenda pode ocupar.
 *
 * 14% de respiro total. Legenda encostando na borda é cortada pelo recorte de algumas
 * plataformas e, mesmo quando não é, fica desconfortável de ler.
 */
export const CAPTION_SAFE_WIDTH = 0.86;
/**
 * Agrupa palavras em linhas.
 *
 * Duas condições fecham uma linha: estourar a largura ou atingir o teto de palavras. A
 * segunda existe porque legenda de vídeo curto tem um limite de palavras por linha que é
 * escolha de estilo, não de espaço.
 *
 * Uma palavra sozinha mais larga que a linha fica na própria linha em vez de ser partida:
 * quebrar palavra no meio é pior que estourar um pouco.
 */
export function wrapCaptionWords(words, options) {
    const lines = [];
    let current = [];
    let width = 0;
    const spaceWidth = estimateTextWidth(' ', options.fontSize, options.letterSpacing);
    for (const word of words) {
        const text = options.uppercase ? word.text.toUpperCase() : word.text;
        const wordWidth = estimateTextWidth(text, options.fontSize, options.letterSpacing);
        const overflows = current.length > 0 &&
            (width + spaceWidth + wordWidth > options.maxWidth || current.length >= options.maxWordsPerLine);
        if (overflows) {
            lines.push(current);
            current = [];
            width = 0;
        }
        current.push(word);
        width += (current.length > 1 ? spaceWidth : 0) + wordWidth;
    }
    if (current.length > 0)
        lines.push(current);
    return lines;
}
//# sourceMappingURL=text.js.map